export default __webpack_public_path__ + "static/media/laptop-2.91f5289e.gif";